import React, { useState , useEffect } from 'react';
import { Form, message, Modal } from "antd";
import DynamicField from "./dynamic-trip-stops";
import { getCloneArray, isValid, isValidArray } from '../../../utils/utilities';
import { CreateStandardStopsPage } from "../../../pages/create-standard-stop.page";
import { useDispatch, useSelector } from 'react-redux';
import { activeCitySelector, activeStopsSelector } from '../../../selector/trip-create.selector';
import { setActiveStop } from '../../../actions/trip-create.actions';
import { getStandardStopsForCities } from '../../../actions/address.actions';


export const TripStops = (props) => {

    const {
        addressLocation,
        tripScheduleId,
        getCityAddress,
        isModal,
        setModal,
        onCallBackNextButton,
        setEnableLocationPick,
        childRef,
        cityName
    } = props;


    const [editableAddress,setEditableAddress] = useState({});
    const [editableAddressIndex,setEditableAddressIndex] = useState(null);
    const [standardStops,setStandardStops] = useState([]);

    const dispatch = useDispatch();

    const [form] = Form.useForm();

    let activeStops = useSelector(activeStopsSelector);
    let activeCity = useSelector(activeCitySelector);

    useEffect(() => {
      if(!isModal){
        let clonedStops =[];
        if (isValidArray(activeStops)) {
           clonedStops = getCloneArray(activeStops);
        }
          clonedStops.push({});
          setEditableAddress({});
          setEditableAddressIndex(null);

        form.setFieldsValue({'fields':clonedStops});
        if(activeStops.length>0){
          onCallBackNextButton(false);
        }else{
          onCallBackNextButton(true);
        }
      }
    },[activeStops,isModal]);

    useEffect(()=>{
      getStandardStopsForCities([activeCity.city_name],(data)=>{
        setStandardStops(data.addressLocations);
      },()=>{
        setStandardStops([]);
        message.error(`Failed to get standard stops for ${activeCity.city_name}`);
      })
      setModal(false);
    },[activeCity])
    
  return (
    <div style= {{margin:10}}>
      <Form.Provider>
        <Form name="basicForm" form={form}>
          <DynamicField 
              form={form}
              addressLocation = {isValid(addressLocation)?addressLocation:[]}
              setModal = {setModal}
              isModal={isModal}
              setAddressFormData={(address,index)=>{
                setEditableAddress(address);
                setEditableAddressIndex(index);
                dispatch(setActiveStop(address,index));
              }}
              setEditableAddressIndex={setEditableAddressIndex}
              onCreateNewStop={(index)=>{
                setEditableAddress({});
                setEditableAddressIndex(index);
                setModal(true);
              }}
              standardStops={standardStops}
              activeStops={activeStops}
              cityName={cityName}
          />
        </Form>
        {isModal&&
           <Modal
              title={null}
              className="createNewStopModal"
              visible={isModal}
              width="95vw"
              onCancel={()=>{
                setModal(false);
                setEditableAddress({});
              }}
              centered={true}
              footer={null}
              destroyOnClose={true}
            >
              <CreateStandardStopsPage
                fromModal={true}
                isAddressBook={true}
                selectedCity={activeCity.city_name}
                operatorCode={global.operatorCode}
                onSuccessRefresh={(id,savedRecord)=>{
                  getCityAddress();
                  if(isValid(savedRecord)){
                    dispatch(setActiveStop(savedRecord,editableAddressIndex));
                  }
                  setModal(false);
                  setEditableAddress({});
                }}
                onFailureRefresh={(errMsg)=>{
                  message.error(errMsg);
                }}
                formDetailsFromprops={(isValid(editableAddress)&&isValid(editableAddress.id))?editableAddress:null}
                  cancelModal={()=>{
                    setModal(false);
                    setEditableAddress({});
                  }}
              />
            </Modal>
        }
       
      </Form.Provider>
    </div>
  );
}